// extracted by mini-css-extract-plugin
export default {"delete":"kmlvu___HoverMenu-module__delete","dnd":"_9t0hS___HoverMenu-module__dnd","viewImage":"F9mkp___HoverMenu-module__viewImage","imageLink":"htbLJ___HoverMenu-module__imageLink"};